<template>
  <div class="staff-filter">
    <div class="staff-filter__fields d-md-flex align-center">
      <div class="staff-filter-col">
        <div class="staff-filter-col__content">
          <filial-select-wits-presets :value="null" @change="changeFilialFilter" />
        </div>
      </div>

      <div class="staff-filter-col">
        <div class="staff-filter-col__content">
          <v-select
            v-model="roleIds"
            :items="roles"
            item-text="title"
            item-value="id"
            label="Должность (роли)"
            multiple
            hide-details="auto"
            background-color="#fff"
            height="40"
            style="border-radius: 10px"
            flat
            solo
            :loading="rolesLoading"
            :disabled="rolesLoading"
            :menu-props="{ maxHeight: '90vh' }"
            no-data-text="Роли не найдены"
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="roleIds.length === 1">{{ item.title }}</span>
              <span v-else-if="index === 0">
                Выбрано: {{ roleIds.length }}
              </span>
            </template>
          </v-select>
        </div>
      </div>

      <div class="staff-filter-col">
        <v-btn
          style="border-radius: 10px"
          height="48px"
          depressed
          color="#D3D5D9"
          @click="applyFilter"
        >
          Применить
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import snackbarMessage from '@/mixins/snackbar-message'
  import FilialSelectWitsPresets from '@/components/ui/filial-with-presets/FilialSelectWitsPresets.vue'

  export default {
    name: 'StaffTopFilter',
    components: { FilialSelectWitsPresets },
    mixins: [snackbarMessage],
    data () {
      return {
        roles: [],
        rolesLoading: false,
        roleIds: [],
        filialId: null,
        filialPreset: null,
      }
    },
    async created () {
      this.rolesLoading = true
      try {
        this.roles = await this.$store.dispatch('roles/fetchViewableRoleList')
      } catch (e) {
        this.showErrorFromResponse(e)
      } finally {
        this.rolesLoading = false
      }
    },
    methods: {
      changeFilialFilter (data) {
        this.filialId = null
        this.filialPreset = null

        if (data && data.id) {
          if (data.type === 'filial') {
            this.filialId = data.id
          } else {
            this.filialPreset = data.id
          }
        }
      },
      applyFilter () {
        this.$emit('applyFilter', {
          filialId: this.filialId,
          filialPreset: this.filialPreset,
          roleIds: [...this.roleIds],
        })
      },
    },
  }
</script>

<style lang="less" scoped>
.staff-filter {
  padding: 9px 15px;
  background: #f1f3f6;
  border-radius: 8px;
  margin-bottom: 5px;

  .staff-filter-col {
    display: flex;
    align-items: center;
    margin-right: 15px;

    &__content {
      min-width: 220px;
      max-width: 300px;
    }
  }

  @media (max-width: 768px) {
    .staff-filter__fields {
      flex-direction: column;
      align-items: stretch;
    }

    .staff-filter-col {
      margin: 0 0 8px;
      width: 100%;

      .staff-filter-col__content {
        max-width: 100%;
        width: 100%;
      }

      .v-btn {
        width: 100%;
      }
    }
  }
}
</style>
